import { Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './Pages/Home';
import HomeElezioni from './Pages/HomeElezioni';
import HomeComunali from './Pages/HomeComunali';
import HomeComunali2025 from './Pages/HomeComunali2025';
import HomeComunaliB from './Pages/HomeComunaliB';
import Regione from './Pages/Regione';
import RegioneComunali from './Pages/RegioneComunali';
import RegioneComunali2025 from './Pages/RegioneComunali2025';
import RegioneComunaliB from './Pages/RegioneComunaliB';
import Provincia from './Pages/Provincia';
import Circosrizione from './Pages/Circoscrizione';
import ProvinciaComunali from './Pages/ProvinciaComunali';
import ProvinciaComunali2025 from './Pages/ProvinciaComunali2025';
import ProvinciaComunaliB from './Pages/ProvinciaComunaliB';
import Comune from './Pages/Comune';
import ComuneComunali from './Pages/ComuneComunali';
import ComuneComunali2025 from './Pages/ComuneComunali2025';
import ComuneComunaliB from './Pages/ComuneComunaliB';
import HomeEuropeeItalia from './Pages/HomeEuropeeItalia';
import HomeEuropeePreferenze from './Pages/HomeEuropeePreferenze';
import HomeEuropeeEuropa from './Pages/HomeEuropeeEuropa';
import CircoscrizioneEuropee from './Pages/CircoscrizioneEuropee';
import RegioneEuropee from './Pages/RegioneEuropee';
import ProvinciaEuropee from './Pages/ProvinciaEuropee';
import ComuneEuropee from './Pages/ComuneEuropee';
import ENEuropee from './Pages/ENEuropee';
import HomeElectionDay2025 from './Pages/HomeElectionDay2025';
import HomeReferendum2025 from './Pages/HomeReferendumb2025';
import HomeReferendum2026 from './Pages/HomeReferendum2026';
import HomeReferendumb2025 from './Pages/HomeReferendumb2025';
import RegioneReferendum2025 from './Pages/RegioneReferendum2025';
import ProvinciaReferendum2025 from './Pages/ProvinciaReferendum2025';
import ComuneReferendum2025 from './Pages/ComuneReferendum2025';
import RegioneReferendum2026 from './Pages/RegioneReferendum2026';
import ProvinciaReferendum2026 from './Pages/ProvinciaReferendum2026';
import ComuneReferendum2026 from './Pages/ComuneReferendum2026';

//COMUNALI 2026
import HomeComunali2026 from './Pages/HomeComunali2026';
import RegioneComunali2026 from './Pages/RegioneComunali2026';
import ProvinciaComunali2026 from './Pages/ProvinciaComunali2026';
import ComuneComunali2026 from './Pages/ComuneComunali2026';
import HomeComunali2026B from './Pages/HomeComunali2026B';
import RegioneComunali2026B from './Pages/RegioneComunali2026B';
import ProvinciaComunali2026B from './Pages/ProvinciaComunali2026B';
import ComuneComunali2026B from './Pages/ComuneComunali2026B';

function App() {
  return (
	<>
		<Routes>
			<Route path="/" element={<Home />} />
			<Route path="/elezioni/" element={<HomeElezioni />} />
			<Route path="/elezioni/comunali-2026/" element={<HomeComunali2026B />} />
			<Route path="/elezioni/comunali-2026/:regione/" element={<RegioneComunali2026B />} />
			<Route path="/elezioni/comunali-2026/:regione/:provincia" element={<ProvinciaComunali2026B />} />
			<Route path="/elezioni/comunali-2026/:regione/:provincia/:comune" element={<ComuneComunali2026B />} />

			<Route path="/elezioni/comunali-2025/" element={<HomeComunali2025 />} />
			<Route path="/elezioni/comunali-2025/:regione/" element={<RegioneComunali2025 />} />
			<Route path="/elezioni/comunali-2025/:regione/:provincia" element={<ProvinciaComunali2025 />} />
			<Route path="/elezioni/comunali-2025/:regione/:provincia/:comune" element={<ComuneComunali2025 />} />
			<Route path="/elezioni/regionali-2025/:regione/" element={<Regione />} />
			<Route path="/elezioni/regionali-2025/:regione/:provincia" element={<Provincia />} />
			<Route path="/elezioni/regionali-2025/:regione/:provincia/:comune" element={<Comune />} />
			<Route path="/elezioni/comunali-2024/" element={<HomeComunali />} />
			<Route path="/elezioni/comunali-ballottaggio-2024/" element={<HomeComunaliB />} />
			<Route path="/elezioni/comunali-2024/:regione/" element={<RegioneComunali />} />
			<Route path="/elezioni/comunali-ballottaggio-2024/:regione/" element={<RegioneComunaliB />} />
			<Route path="/elezioni/comunali-2024/:regione/:provincia" element={<ProvinciaComunali />} />
			<Route path="/elezioni/comunali-ballottaggio-2024/:regione/:provincia" element={<ProvinciaComunaliB />} />
			<Route path="/elezioni/comunali-2024/:regione/:provincia/:comune" element={<ComuneComunali />} />
			<Route path="/elezioni/comunali-ballottaggio-2024/:regione/:provincia/:comune" element={<ComuneComunaliB />} />
			<Route path="/elezioni/europee-2024/" element={<HomeEuropeeItalia />} />
			<Route path="/elezioni/europee-2024/europa" element={<HomeEuropeeEuropa />} />
			<Route path="/elezioni/europee-2024/preferenze" element={<HomeEuropeePreferenze/>} />
			<Route path="/elezioni/europee-2024/europa/:nazione" element={<ENEuropee />} />
			<Route path="/elezioni/europee-2024/:circoscrizione" element={<CircoscrizioneEuropee />} />
			<Route path="/elezioni/europee-2024/:circoscrizione/:regione/" element={<RegioneEuropee />} />
			<Route path="/elezioni/europee-2024/:circoscrizione/:regione/:provincia" element={<ProvinciaEuropee />} />
			<Route path="/elezioni/europee-2024/:circoscrizione/:regione/:provincia/:comune" element={<ComuneEuropee />} />
			<Route path="/elezioni/electionday-2025/" element={<HomeElectionDay2025 />} />
			<Route path="/elezioni/referendum-2025/" element={<HomeReferendum2025 />} />
			<Route path="/elezioni/referendumb-2025/" element={<HomeReferendumb2025 />} />
			<Route path="/elezioni/referendum-2025/:regione" element={<RegioneReferendum2025 />} />
			<Route path="/elezioni/referendum-2025/:regione/:provincia" element={<ProvinciaReferendum2025 />} />
			<Route path="/elezioni/referendum-2025/:regione/:provincia/:comune" element={<ComuneReferendum2025 />} />
			<Route path="/elezioni/referendum-2026/" element={<HomeReferendum2026 />} />
			<Route path="/elezioni/referendum-giustizia-2026/" element={<HomeReferendum2026 />} />
			<Route path="/elezioni/referendum-2026/:regione" element={<RegioneReferendum2026 />} />
			<Route path="/elezioni/referendum-giustizia-2026/:regione" element={<RegioneReferendum2026 />} />
			<Route path="/elezioni/referendum-2026/:regione/:provincia" element={<ProvinciaReferendum2026 />} />
			<Route path="/elezioni/referendum-giustizia-2026/:regione/:provincia" element={<ProvinciaReferendum2026 />} />
			<Route path="/elezioni/referendum-2026/:regione/:provincia/:comune" element={<ComuneReferendum2026 />} />
			<Route path="/elezioni/referendum-giustizia-2026/:regione/:provincia/:comune" element={<ComuneReferendum2026 />} />
		</Routes>
	</>
  );
}

export default App;

